/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Placeholder, PlaceholderText } from 'sarsaparilla';
import './FacilitySummaryIconsPlaceholder.scss';

export default function FacilitySummaryIconsPlaceholder() {
    return (
        <div
            className="campground-page-v3-facility-summary-icons-placeholder"
            aria-hidden="true"
        >
            {Array.from({ length: 6 }).map((_, index) => (
                <div
                    key={`facility-summary-icon-placeholder-${index}`}
                    className="campground-page-v3-facility-summary-icons-placeholder-row"
                >
                    <Placeholder height="20px" width="20px" />
                    <div className="campground-page-v3-facility-summary-icons-placeholder-text">
                        <PlaceholderText
                            fontSize={23}
                            lineHeight={24}
                            lines={1}
                            width="80%"
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}
